import Axios from 'axios';
import ENV from './env';

function getAccessToken() {
  return localStorage.getItem('access_token');
}

export default {
  getUserDashboardVideos(agencyId) {
    return Axios.get(`${ENV.ERP_PORT}/api/v1/bm/dashboard/videos?per_page=500&type=advertiser&client_id=${agencyId}`, {
      params: {
        access_token: getAccessToken(),
      },
    })
    .then((response) => {
      const resultData = response.data;

      const {
        success,
        message,
        data,
      } = resultData;

      return {
        _data: data,
        _success: success,
        _message: message,
      };

    })
    .catch(error => console.log(error));
  },

  getUserDashboardVideosDetail(videoData) {

    const {
      videoId,
      agencyId,
    } = videoData;

    return Axios.get(`${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${videoId}?client_id=${agencyId}`, {
      params: {
        access_token: getAccessToken(),
      },
    })
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        data,
      } = resultData;

      return {
        detailData: data,
        _success: success,
        _message: message,
      };

    })
    .catch(error => console.log(error));
  },

  getDashboardDesktopSummary(urlData) {

    const {
      videoId,
      type,
      clientId,
    } = urlData;

    return Axios(`${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${videoId}/summary?client_id=${clientId}&type=${type}&device=desktop`, {
      params: {
        access_token: getAccessToken(),
      },
    })
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        data,
      } = resultData;

      return {
        data,
        _success: success,
        _message: message,
      };

    })
    .catch(error => console.log(error));
  },

  getDashboardMobileSummary(urlData) {

    const {
      videoId,
      type,
      clientId,
    } = urlData;

    return Axios(`${ENV.ERP_PORT}/api/v1/bm/dashboard/videos/${videoId}/summary?client_id=${clientId}&type=${type}&device=mobile`, {
      params: {
        access_token: getAccessToken(),
      },
    })
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        data,
      } = resultData;

      return {
        data,
        _success: success,
        _message: message,
      };

    })
    .catch(error => console.log(error));
  },

};



// WEBPACK FOOTER //
// ./src/services/dashboard.js